const defaultDarkOptions = {
  darkTicksColor: "#fff",
  darkLabelColor: "#fff",
  darkGridLinesColor: "#555",
  darkBgColor: "#262626",
  darkBgColorLight: "#fff",
};

export default defaultDarkOptions;
